'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const PreviewContext = React__default.createContext();
const PreviewProvider = ({
  children,
  pluginOptions,
  ...props
}) => {
  const [typePaths, setTypePaths] = React.useState(null);
  const asyncEffect = React.useCallback(async () => {
    const {
      repositoryName
    } = pluginOptions;
    const req = await fetch(`${__PATH_PREFIX__}/prismic__${repositoryName}__typeDefs.json`);
    const data = await req.text();
    const typePaths = JSON.parse(data);
    setTypePaths(typePaths);
  }, [pluginOptions]);
  React.useEffect(() => {
    asyncEffect();
  }, [asyncEffect]);
  const memoizedValues = React.useMemo(() => ({
    pluginOptions,
    typePaths
  }), [pluginOptions, typePaths]);
  return React__default.createElement(PreviewContext.Provider, _extends({
    value: memoizedValues
  }, props), children);
};

const wrapPageElement = ({
  element,
  props
}, pluginOptions) => React__default.createElement(PreviewProvider, _extends({
  pluginOptions: pluginOptions
}, props), element);

exports.wrapPageElement = wrapPageElement;
